module.exports = __webpack_public_path__ + "static/img/wc_2.018ec8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wc_2.jpg
// module id = 3Xwn
// module chunks = 1